import { Swiper } from 'swiper'

$('body').on('click', '[data-ct-tab]', function (e){
  e.preventDefault()
  const $tabs = $(this).closest('.content-tabs')
  const setTab = $(this).attr('data-ct-tab')
  const $activeTabs = $tabs.find(`[data-ct-tab="${setTab}"]`)

  $tabs.find('.active').removeClass('active')
  $activeTabs.addClass('active')
})

let ct_swiper = new Swiper(".content-tabs-swiper", {
  slidesPerView: "auto",
  spaceBetween: 0,
  freeMode: true
});
